import React from 'react';
import TemplateTabs from '../templateTabs/TemplateTabs';
import ActionWidget from '../../../../actionWidget/ActionWidget';
import TemplateBadgeElementList from '../templateBadgeElementList/TemplateBadgeElementList';
import styles from './TemplateTabsWithWidgets.module.css';

const TemplateTabsWithWidgets = ({
  templateTabsState,
  templateItemsByType,
  templatesTypeName,
  templatesTypeItem,
  doesCurrentTemplatesTypeItemExist,
}) => {
  return (
    <TemplateTabs
      templateItemsByType={templateItemsByType}
      templatesTypeName={templatesTypeName}
      {...templateTabsState}
    >
      <div className={styles.tabPanelContent}>
        <ActionWidget
          className={styles.tabPanelContent_createWidget}
          icon={'fas fa-plus'}
          onClick={templatesTypeItem.actions.onClickCreateTemplateButton}
          disabled={!templatesTypeItem.canCreateTemplate}
          aria-label={`Agregar plantilla de tipo ${templatesTypeItem.displayName}`}
        >
          Agregar plantilla de tipo {templatesTypeItem.displayName}
        </ActionWidget>
        {templatesTypeItem.name === 'Agreements' && templatesTypeItem.canUseIATemplate && (
          <ActionWidget
            icon={'fas fa-plus'}
            onClick={templatesTypeItem.actions.onClickIaCreateTemplateButton}
            disabled={!templatesTypeItem.canCreateTemplate}
            aria-label={`Agregar plantilla de tipo ${templatesTypeItem.displayName}`}
          >
            Acuerdos IA
          </ActionWidget>
        )}
        {doesCurrentTemplatesTypeItemExist && (
          <TemplateBadgeElementList
            className={styles.tabPanelContent_templateList}
            templateElementList={templatesTypeItem}
          />
        )}
      </div>
    </TemplateTabs>
  );
};

export default TemplateTabsWithWidgets;
